'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function projectContactTable() {
    return {
        restrict: 'A',
        template: require('../view/project-maintenance-responsibility-table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isFilter: '=myFilter',
            edit: '=edit',
            ids: '=myIds',
        },
        controller: ['$scope', '$utils', 'OrgService', 'StaffService',
            function ($scope, $utils, OrgService, StaffService) {

                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.selectStaff = selectStaff;

                init();

                // region Function

                function init() {

                    if (!$scope.selectedItem)
                        $scope.selectedItem = {};

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $scope.edit,
                                click: () => OrgService.select({}, $scope.ids.map(item => `'id' EQ '${item.org}'`), []).result.then(function (data) {
                                    if (!$scope.items.some(item => item.responsibleOrg.id == data.id)) {
                                        $scope.items.push({responsibleOrg: data});
                                    }
                                }),
                                disabled: () => false,
                            },
                            remove: {
                                show: () => $scope.edit,
                                click: (item) => $scope.items.splice($scope.items.indexOf($scope.items.find(it => it.responsibleOrg.id == item.responsibleOrg.id)), 1),
                                disabled: () => !($scope.selectedItem.responsibleOrg && $scope.selectedItem.responsibleOrg.id),
                            },
                            refresh: {
                                show: () => false,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        }
                    };
                }

                function refresh() {
                    if (Array.isArray($scope.items)) {
                        if ($scope.items.every(i => i.responsibleOrg.id != $scope.selectedItem.responsibleOrg.id)) {
                            $scope.selectedItem = {};
                        }
                    }
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            if ($scope.toolbox.buttons.edit) {
                                $scope.toolbox.buttons.edit.click(item);
                            }
                            break;
                        case 'select' :
                            $scope.ok(item);
                            break;
                    }
                }

                function select(item) {
                    if (!$scope.selectedItem.responsibleOrg || $scope.selectedItem.responsibleOrg.id !== item.responsibleOrg.id) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                function isSelect(item) {
                    return $scope.selectedItem.responsibleOrg != null ? $scope.selectedItem.responsibleOrg.id === item.responsibleOrg.id : false;
                }

                function getItems() {
                    return $scope.items;
                }

                function selectStaff(item) {
                    const currentOrg = $scope.ids.find(org => org.org === item.responsibleOrg.id);
                    const orgStaff = currentOrg ? currentOrg.staff : [];
                    StaffService.select(item.responsibleStaff, orgStaff.map(staff => `'id' EQ '${staff}'`), {}).result.then(function (data) {
                        item.responsibleStaff = data;
                    });
                }

                // endregion

            }]
    };
}